import { html, LitElement, type PropertyValueMap, adoptStyles } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import { property } from 'lit/decorators/property.js';
import "@rhds/elements/rh-cta/rh-cta.js";

import styles from './rhpt-link.css';
import rhCtaTweaks from './rh-cta-tweaks.css';

@customElement('rhpt-link')
export class RhptLink extends LitElement {

  static readonly styles = [styles];

  @property()
  icon?: string;

  @property()
  set?: string;

  @property({ type: Boolean, attribute: 'no-icon' })
  noIcon?: boolean;

  firstUpdated() {
    this.#setUpdated();
  }

  async connectedCallback() {
    super.connectedCallback();
    // Add a tweaks for content set;
    if (this.noIcon !== true) return;

    await customElements.whenDefined('rh-cta')
    const shadowRoot = this.shadowRoot?.querySelector('rh-cta')?.shadowRoot;
    const stylesheets = shadowRoot?.adoptedStyleSheets;
    if (shadowRoot) {
      adoptStyles(shadowRoot, [...stylesheets ?? [], rhCtaTweaks]);
    }
  }

  protected updated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    if (_changedProperties.has('set')) {
      this.#setUpdated;
    }
  }

  #setUpdated() {
    customElements.whenDefined('rh-cta')
      .then(async () => {
        await this.updateComplete;
        const icon = this.shadowRoot?.querySelector('rh-cta')?.shadowRoot?.querySelector('pf-icon');
        if (this.set) icon?.setAttribute('set', this.set);
      });
  }

  render() {
    return html`
      <rh-cta icon=${this.icon ?? ''} ?no-icon=${this.noIcon}>
        <slot></slot>
      </rh-cta>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rhpt-link': RhptLink;
  }
}
